import { connect } from "react-redux";

import { Creators } from "../../../../services/redux/vignets/actions";
import VignetVerification from "./components";

const mapStateToProps = (state) => {
  const { isCheckingMooringVignette, error } = state.vignets;
  return {
    isCheckingMooringVignette,
    error,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    checkMooringVignette: (data) => {
      dispatch(Creators.checkMooringVignette(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VignetVerification);
